export const seoBoxContainerId = 'sportsbook-seo-box';
export const subFeatureContainerId = 'sportsbook-sub-feature';

export const components = {
    SEO_BOX: 'seoBox',
    SUB_FEATURE: 'subFeature',
};
